module.exports = __webpack_public_path__ + "static/aboutUs-6ed1c2a548fe6d9254bca4057ede098d.jpg";